<template>
  <div> 
    <van-button
      round
      plain
      normal
      hairline
      v-if="orderItem && orderItem.IS_COUPON"
      size="small"
      @click="onCustomerClick"
      >在线客服</van-button
    >
    <van-button
      class="div-btn-a"
      round
      plain  
      normal
      hairline
      v-else-if="role == 'bees'"
      size="small"
      @click="contactFun2"
      >联系客户</van-button
    >
    <div v-else-if="role !== 'bees' && isVirtual === 'n'">
      <van-button
        round
        plain
        normal
        hairline
        v-if="couponPackageId"
        size="small"
        @click="onCustomerClick"
        >在线客服</van-button>
      <van-button
        round
        plain
        normal
        hairline
        v-else
        size="small"
        @click="contactFun1"
        >联系{{$theme.system_text_shoppers}}   </van-button
      >
    </div>
  </div>
</template>
<script>
import Util from "@/utils/common";

export default {
  props: {
    role: {
      type: String,
      default: "user",
      required: false,
      //validator: () => {}
    },
    contactId: {
      // type: String,
      default: "",
      required: true,
    },
    nimname: {
      type: String,
      default: "",
      required: false,
    },
    isVirtual: {
      type: String,
      default: "n"
    },
    orderItem: Object,
    couponPackageId:{
      type:Number ,
    }
  },
  data() {
    return {
      gioObj: {
        entryShape_var: "订单模块",
        entryPage_var: document.title,
        functionName_var: "联系蜜蜂",
        primarySort_var: "",
        secondSort_var: "",
        thirdSort_var: "",
        fourthSort_var: "",
        brand_var: "",
        productName_var: "",
      },
    };
  },
  methods: {
    contactFun1() {
      let that = this;
      Util.contactBees(this.contactId);
      that.$publicFunc.getJumpSingeOrTeam({
        statusParmes: {
          branchId: that.contactId,
        },
        teamParmes: {
          branchId: that.contactId,
        },
        callback: function (status, teamDetail) {
          Util.beeChatGioReport({
            gio: that.gioObj,
            business: {
              branchId: that.contactId,
              key: "easemob",
              teamChatId:
                status.isTeamChat && teamDetail.teamChatId
                  ? teamDetail.teamChatId
                  : "",
            },
          });
        },
      });
    },
    contactFun2() {
      Util.userChat(this.contactId);
    },
    onCustomerClick() {
      Util.toOnlineCustomer(this)
    }
  },
  created() {},
  components: {},
};
</script>
<style lang="less" scoped>
  .div-btn-a {
    // border-radius: 30px;
    min-width: 160px;
    font-size: 24px;
    height: 60px;
    line-height: 70px;
    text-align: center;
    margin-right: 20px;
    // margin-bottom: 10px;
    color: #333333;
  }
  /deep/button[normal] {
    flex-shrink: 0;
    padding: 0;
    width: 160px;
    font-weight: 400;
    line-height: 1;
    // margin: 5px 0;
  }
  /deep/.van-button--default[normal] {
    border-color: #999999 !important;
  }
  /deep/.button-active[normal] {
    font-weight: 500;
    background: linear-gradient(90deg, #ff8200 0%, #ff1414 100%);
    color: #ffffff;
    border: 0px;
    &::after, &::before {
      border-width: 0;
    }
  }
  .print_btn {
  width: 150px;
  // padding: 0 27px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border-radius: 32px;
  border: 1px solid #999999;
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  margin: 20px 0;
  // margin-right: 20px;
  &.disabled {
    background: #F2F2F2;
    color: #999999;
    border: 1px solid #F2F2F2;

  }
  .hold_on {
    width: 32px;
    height: 32px;
    margin-left: 8px;
    animation: rotateImg 1s infinite linear;
    
  }
  }
  @keyframes rotateImg {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>